import { Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import {
  status,
  statusCode,
  toastTypesKeys,
} from "../../../../utils/constants";
import { useCallback, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { toastHandler } from "../../../../utils/helpers";
import { ConfirmationDialogs } from "../../../admin/data/features";
import { ToastContainer } from "react-toastify";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useNavigate } from "react-router-dom";

const peopleStatusUpdate = gql`
  mutation UpdatePersonStatus($personInput: PersonStatusUpdateInput!) {
    personStatusUpdate(input: $personInput) {
      clientMutationId
      person {
        country {
          name
        }
        createdAt
        firstname
        id
        lastname
        picture {
          source
          originalFilename
        }
        status
        title
        updatedAt
      }
    }
  }
`;

const personDeleteMutationDocument = gql`
  mutation personDelete($person: PersonDeleteInput!) {
    personDelete(input: $person) {
      person {
        id
      }
    }
  }
`;

function AdminActions({ item, refetch }: any) {
  const [isOpen, setIsOpen] = useState<any>({
    status: false,
    currId: null,
    moduleCode: 2,
  });
  const [rejectReason, setRejectReason] = useState("");
  const [isError, setIsError] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { translator } = useLanguageTranslator();
  const { user } = useAuthSession() as any;
  const notify = useNotify();
  const navigate = useNavigate();

  const [peopleStatus] = useMutation(peopleStatusUpdate, {
    context: {
      headers: {
        "access-token": user?.accessToken,
        client: user?.client,
        uid: user?.email,
      },
    },
  });

  const [deletePeopleMutation, { loading: deletingPeople }] = useMutation(
    personDeleteMutationDocument,
    {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  async function onClickHandler(peopleID: number) {
    if (isOpen?.moduleCode === statusCode.approved) {
      try {
        const response = await peopleStatus({
          variables: {
            personInput: { id: Number(peopleID), status: "Approved" },
          },
        });
        if (response?.data) {
          setIsOpen({ status: false, currId: null, module: "" });
          toastHandler("Status is Updated", toastTypesKeys.success);
          setTimeout(() => {
            refetch();
          }, 2300);
        }
      } catch (error) {
        console.error("Error:", error);
        setIsOpen({ status: false, currId: null, module: "" });
        setIsError(true);
      }
      return;
    }

    if (!rejectReason)
      return toastHandler("Please enter the Reason", toastTypesKeys.error);

    try {
      const response = await peopleStatus({
        variables: {
          personInput: {
            id: Number(peopleID),
            status: "Rejected",
            reason: rejectReason,
          },
        },
      });
      if (response?.data) {
        setIsOpen({ status: false, currId: null, module: "" });
        toastHandler("Status is Updated", toastTypesKeys.success);
        setTimeout(() => {
          refetch();
        }, 2300);
        setRejectReason("");
      }
    } catch (error) {
      console.error("Error:", error);
      setIsOpen({ status: false, currId: null, module: "" });
      setRejectReason("");
      setIsError(true);
    }
  }

  function onAdminActions(id: any, type: any) {
    setIsOpen({ status: true, currId: id, moduleCode: type });
  }

  const handleDelete = useCallback(
    async (personId: any) => {
      try {
        const response = await deletePeopleMutation({
          variables: { person: { id: personId } },
        });
        notify.success(`People Deleted successfully!`);
        if (response?.data) {
          navigate(`/admin/people`);
        }
      } catch (err) {
        notify.error(err as Error);
      }
    },
    [deletePeopleMutation, notify]
  );

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  async function onClickDeleteHandler(deleteData: any) {
    await handleDelete(deleteData?.id);
  }

  function onClickButtonDeleteHandler(clickedItem: any) {
    setIsOpenDelete({ status: true, data: clickedItem });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <ToastContainer />
      <ConfirmationDialogs
        text={`people`}
        viewPath={`/admin/person_detail?id=${isOpen?.currId}`}
        isOpen={isOpen}
        onClickHandler={onClickHandler}
        setIsOpen={setIsOpen}
        rejectReason={rejectReason}
        setRejectReason={setRejectReason}
        isError={isError}
        setIsError={setIsError}
      />
      <Stack
        direction={{ lg: "row" }}
        justifyContent={{ lg: "end" }}
        gap={1}
        sx={{ backgroundColor: "white", pr: 2, pb: 1 }}
      >
        <Button
          sx={{
            px: 6,
            backgroundColor:
              item?.status === status?.approved ? "#FF6D6D" : "#52D777",
            color: "#ffffff",
            "&:hover": {
              backgroundColor:
                item?.status === status?.approved ? "#CC4C4C" : "#3BAA50",
            },
            fontSize: "14px",
          }}
          onClick={() =>
            onAdminActions &&
            onAdminActions(
              item?.id,
              item?.status === status?.approved
                ? statusCode.rejected
                : statusCode.approved
            )
          }
        >
          {item?.status === status?.approved
            ? translator("status.Reject")
            : translator("status.Approve")}
        </Button>
        <Link
          style={{
            padding: 6,
            backgroundColor: "#F6A000",
            color: "#ffffff",
            // "&:hover": {
            //   backgroundColor: "#D48B00",
            // },
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            fontSize: "14px",
            width: "13%",
          }}
          to={`/admin/people/${item?.id}/edit`}
        >
          {translator("generic.EDIT")}
        </Link>
        <Button
          sx={{
            px: 6,
            backgroundColor: "#CD0A0A",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#A10808",
            },
            fontSize: "14px",
          }}
          onClick={() => onClickButtonDeleteHandler(item)}
        >
          {translator("generic.DELETE")}
        </Button>
      </Stack>
    </>
  );
}

export { AdminActions };
